import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { PureComponent } from 'react';
import { CSATChromePreview } from '../CSATChromePreview';
import { CSATWidgetMessage } from '../CSATWidgetMessage';
import styles from './index.module.scss';
export class CSATFollowUpPreview extends PureComponent {
    render() {
        const { className, question, placeholder } = this.props;
        return (_jsx(CSATChromePreview, Object.assign({ className: className }, { children: _jsx(CSATWidgetMessage, { children: _jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", Object.assign({ className: styles.question, dir: "auto" }, { children: question })), _jsxs("div", Object.assign({ className: styles.followUp }, { children: [_jsx("div", Object.assign({ className: styles.placeholder, dir: "auto" }, { children: placeholder })), _jsx("br", {}), _jsx(DixaIcon, { icon: "paper-plane", className: styles.send, size: "16", line: "16" })] }))] })) }) })));
    }
}
